import React from "react";
import { Input } from "../../../Helpers/Input/Input";
import trans from "../../../../utils";
import { useSelector } from "react-redux";

export default function FuelSupport({ addData }) {
  const inf = useSelector((state)=>state.users.user)
  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <Input
          title={`${trans("Fuel Capacity")} (${
                        inf.attributes.volumeUnit
                          ? trans(inf.attributes.volumeUnit)
                          : trans("ltr")
                      })`}
            type="text"
            placeholder={trans("Fuel Capacity")}
            id="fuelCapacity"
            name="fuelCapacity"
            formstyle="form-input"
            onBlur={addData.handleBlur}
            onChange={addData.handleChange}
            errors={addData.errors.fuelCapacity}
            touched={addData.touched.fuelCapacity}
            value={addData.values.fuelCapacity || ""}
          />
        </div>
        <div className="col-lg-6">
          {" "}
          <Input
            title={trans("Tank Height")}
            type="text"
            placeholder={trans("Tank Height")}
            id="tankHeight"
            name="tankHeight"
            formstyle="form-input"
            onBlur={addData.handleBlur}
            onChange={addData.handleChange}
            errors={addData.errors.tankHeight}
            touched={addData.touched.tankHeight}
            value={addData.values.tankHeight || ""}
          />
        </div>
        <div className="col-lg-6">
          {" "}
          <Input
            title={trans("Tank Width")}
            type="text"
            placeholder={trans("Tank Width")}
            id="tankWidth"
            name="tankWidth"
            formstyle="form-input"
            onBlur={addData.handleBlur}
            onChange={addData.handleChange}
            errors={addData.errors.tankWidth}
            touched={addData.touched.tankWidth}
            value={addData.values.tankWidth || ""}
          />
        </div>
        <div className="col-lg-6">
          <Input
            title={trans("Tank Length")}
            type="text"
            placeholder={trans("Tank Length")}
            id="tankLength"
            name="tankLength"
            formstyle="form-input"
            onBlur={addData.handleBlur}
            onChange={addData.handleChange}
            errors={addData.errors.tankLength}
            touched={addData.touched.tankLength}
            value={addData.values.tankLength || ""}
          />
        </div>
      </div>
    </>
  );
}
